import {STAGE_DISPLAY_SIZES} from '../lib/layout-constants.js';
import {getHomeworkInfo} from '../lib/homework-info';

const SET_STAGE_SIZE = 'scratch-gui/StageSize/SET_STAGE_SIZE';

const initialState = {
    stageSize: STAGE_DISPLAY_SIZES.small
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_STAGE_SIZE:
        return {
            stageSize: action.stageSize
        };
    default:
        return state;
    }
};

const setStageSize = function (stageSize) {
    const homeworkInfo = getHomeworkInfo();
    const courseId = Number(homeworkInfo.courseId);
    const unitId = Number(homeworkInfo.unitId);
    const lessonId = Number(homeworkInfo.lessonId);
    localStorage.setItem('stageDisplayMode', `${stageSize}`);
    ht.track(`s3_stage_${stageSize}`, {
        context: {
            courseId: courseId,
            unitId: unitId,
            lessonId: lessonId,
            currentUrl: location.href,
            stageDisplayMode: `${stageSize}`
        }
    });
    return {
        type: SET_STAGE_SIZE,
        stageSize: stageSize
    };
};

export {
    reducer as default,
    initialState as stageSizeInitialState,
    setStageSize
};
